import React from "react";
import Header from "../Component/Services/Electrical Services/Header";
import SecendSection from "../Component/Services/Electrical Services/SecendSection";
import WideRange from "../Component/Services/Electrical Services/WideRange"
import QuickContact from "../Component/Services/QuickContact4"

function ElectricalServices() {
  return (
    <div>
      <Header />
      <SecendSection />
      <WideRange />
      <QuickContact />
    </div>
  );
}

export default ElectricalServices;
